<template>
<div>
  <van-field
    v-model="formSubmitPwd" 
    label="提交密码" 
    placeholder="输入表单验证密码.." 
    type="text"  
    :required="true" 
    :rules="[{ required: true ,message:'本表单设置了密码..'}]"
    v-if="config.isSubmitPwd"
  />
  <div :style="'padding:'+( schema.paddingTB || 5)+'px '+ ( schema.paddingLR || 5)+'px;background:'+ (schema.bgColor || '#f0f9eb') +';text-align:'+ (schema.textAlign || 'center')">

    <van-button 
      :color="schema.color"
      :plain="schema.plain"
      :square="schema.square != 'round'"
      :round="schema.square == 'round'"
      :icon="schema.icon"
      :size="schema.size"
      :text="schema.label"
      :disabled="submitDisabled && config.isNotRepeat"
      @click="onButtonSubmit()"  
      native-type="submit"
    >
    {{submitDisabled && isNotRepeat ? '您已提交' : schema.label}}
    </van-button>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
// import { Notify } from 'vant';

export default {
  name: 'submit',
  props: {
    schema: {
      'type':Object,
      default:{},
      required:true
    },
    pluginIndex:{
      type:Number,
      default:0
    }
  },
  computed:{
    ...mapState(['config','submitDisabled']),
    formSubmitPwd:{
        get: function () {
            return this.$store.state.formSubmitPwd
        },
        set: function (newValue) {
            this.$store.commit('setFormSubmitPwd',newValue)
        }
    }
  },
  data:function() {
    return {
      // isSubmitPwd: this.config.isSubmitPwd ==1,
      // isNotRepeat: this.config.isNotRepeat ==1,
      // submitDisabled:false,
      // formSubmitPwd:'',//表单密码
    }
  },
  methods:{
    onButtonSubmit:function(){
      this.$store.commit('setSubmitIndex',this.pluginIndex)
    },
    // onScan(){
    //   Notify({ type: 'warning', message: '点击了扫码',duration: 800 });
    // }
  }
}
</script>

<style>

</style>